import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

export default new VueI18n({
  locale: "es", // set default locale
  fallbackLocale: "es",
  silentTranslationWarn: true,
  messages: {
    es: {
      tableHeaders: {
        idEquipo: "Identificador del equipo",
        modelo: "Modelo",
        imei: "IMEI/Id",
        telefono: "Teléfono",
        usuarios: "Usuarios",
        grupo: "Grupo",
        areasAsignadas: "Grupo",
        acciones: "Acciones",
        registros: "Acciones registradas",
        fechaRegistro: "Fecha de registro",
        nombre: "Nombre",
        alerta: "Alerta",
        usuario: "Usuario",
        dispositivos: "Dispositivos",
        rol: "Rol",
        tipo: "Tipo",
        comercial: "Comercial",
        institucional: "Institucional",
        informacion: "Información general",
      },

      headerGeneralMovil: {
        usuario: "Usuario",
        rol: "Rol",
        grupo: "Grupo",
        accion: "Acción",
        fecha: "Fecha de creación",
        modelo: "Modelo",
        marca: "Marca",
        acciones: "Acciones",
        nombre: "Nombre",
        alerta: "Alerta",
        dispositivo: "Dispositivo",
        telefono: "Teléfono"
      },

      //Traducciones para la barra de navegación
      Starter: "Starter",
      "Monitoreo": "Monitoreo",

      "Dispositivos": "Dispositivos",
      "agregarDispositivo": "Agregar dispositivo",
      "TK108": "Configuración de dispositivo COBAN",
      "TKSTAR": "Configuración de dispositivo TKSTAR",
      "Histórico": "Histórico",
      "Geocercas": "Geocercas",
      "AddGeocercas": "Agregar geocerca",
      "EditGeo": "Editar geocerca",
      "Estadísticas" : "Estadísticas",
      "Usuarios": "Usuarios",
      "Grupos":"Grupos",
      "Bitácora": "Bitácora",
      "Configuraciones":"Configuraciones",
      "Agregar dispositivo": "Agregar dispositivo",
      "Editar dispositivo": "Editar dispositivo",
      "Agregar geocerca": "Agregar geocerca",
      "Editar geocerca": "Editar geocerca",
      "Agregar usuario": "Agregar usuario",
      "Editar usuario": "Editar usuario",
      "Marcas": "Marcas",
      "Agregar marca": "Agregar marca",
      "Editar marca": "Editar marca",
      "Modelos": "Modelos",
      "Agregar modelo": "Agregar modelo",
      "Editar modelo": "Editar modelo",
      "Menú": "Menú",

      Gral:{
        agregar: "Agregar",
        cancelar : "Cancelar",
        noRegistros: "No se encontraron registros.",
        busquedaFallida: "No se encontraron resultados para su búsqueda.",
        ver: "Ver",
        editar: "Editar",
        eliminar: "Eliminar",
        hoy: "Hoy",
        latitud: "Latitud",
        longitud: "Longitud",
        radio: "Radio",
        nombre: "Nombre",
        acciones: "Acciones",
        camposObligatorios: "Campos obligatorios",
        tipo: "Tipo",
        dispositivo: "Dispositivo",
        sinSeleccionar: "sin seleccionar",
        seleccionar: "Seleccionar",
        modelo: "Modelo",
        enviar: "Enviar",
        respuesta: "Respuesta",
        alerta: "Alerta",
        aceptar: "Aceptar",
        usuario: "Usuario",
        guardar: "Guardar",
        cerrar: "Cerrar",
        h: "h",
        des: "desh",
        abilitado: "abilitado",
        tel: "Teléfono* :",
        valExitTelefono: "Ingrese teléfono de 10 dígitos",
        medida: "Distancia",
        imgLeyenda:"/assets/img/marcadores-espanol.svg",
        buscar: "Buscar",
        limpiarBusqueda: "Limpiar búsqueda",
        habilitar: "Habilitar",
        deshabilitar: "Deshabilitar",
        rangoFechas: "Rango de fechas",
        seleccionarFecha: "Selecciona el rango de las fechas",
        escribaBuscar: "Escriba para buscar",
        guardarCont: "Guardar y continuar",
        agregarDispo: "Agregar dispositivo",
        msgSesionCaducada: "Sesión cerrada por inactividad.",
        msgEspere: "Por favor espere ...",
        msgSesion: "Iniciar sesión",
        msgErrorDesconocido: "Error desconocido",
        verUsuarios: "Ver usuarios"
      },

      Mapa:{
        zoomInTitle: 'Aumentar zoom',
        zoomOutTitle: 'Disminuir zoom',
        screenFullTitle: 'Ver pantalla completa',
        screenExitTitle: 'Salir de pantalla completa',
        titleDraw: 'Medir distancia(s)',
      },

      monitoreo: "Monitoreo",
      
      notificaciones : "Notificaciones",
      sinNotificaciones: "Sin notificaciones",
      vistaMaster: "Regresar vista master",
      notifSonoras: "Notificaciones sonoras",
      notifTiempoReal: "Ubicación en tiempo real",
      temaOscuro: "Modo oscuro",
      idioma: "Usar en Inglés",
      cerarSesion: "Cerrar sesión",
      vistaMasterQ: "¿Está seguro que desea regresar a la vista Master?",
      popAlarmaSonora: "Alarma sonora {frase}abilitada.",
      popUbicacion: "Ubicación en tiempo real {frase}abilitada.",
      poptemaOscuro: "Modo oscuro {frase}abilitado.",
      popIdioma: "Ahora usa el sistema en Español",
      textoAyuda: "Ayuda",
      
      vModelo:{
        modelo: "Modelo",
        agregarModelo: "Agregar modelo",
        elejirModelo: "Seleccione el modelo",
        guardarModelo: "Guardar modelo",
        msgModelo: "El nombre del modelo debe tener al menos 5 carácteres",
        msgHabilitar: "¿Está seguro que desea {frase}abilitar el modelo?",
        msgHabilitarToast: "El modelo fue {frase}abilitado exitosamente.",
        msgRegistro: "Modelo registrado exitosamente.",
        msgErrorModelo: "Error al registrar el modelo.",
        msgActualizar: "Modelo actualizado exitosamente.",
        msgErrorActualizarModelo: "Error al actualizar el modelo.",
        editarModelo: "Editar modelo",
      },

      vMarca: {
        marca: "Marca",
        agregarMarca: "Agregar marca",
        editarMarca: "Editar marca",
        elejirMarca: "Seleccione una marca",
        msgHabilitar: "¿Está seguro que desea {frase}abilitar la marca?",
        msgHabilitarToast: "La marca fue {frase}abilitada exitosamente.",
        msgRegistro: "Marca registrada exitosamente.",
        msgErrorMarca: "Error al registrar la marca.",
        msgActualizar: "Marca actualizada exitosamente.",
        msgErrorActualizarMarca: "Error al actualizar la marca.",
        msgMarca: "El nombre de la marca debe tenber al menos 4 caracteres",
        msgErrorActualizar: "Error al actualizar el estatus"
      },

      categoriaAlertas: {
        bateriaBaja: 'Batería baja',
        impacto: "Impacto",
        movimiento: "Movimiento",
        auxilio: "Auxilio",
        geocerca: "Geocerca",
        velocidad: "Velocidad",
      },

      //Traducción para componentes de monitoreo
      vMonitoreo:{
        dispositivosUbic:"Dispositivos y ubicaciones",
        listadoAlertas: "Listado de alertas",
        verTodos: "Ver todos",
        ocultarTodos: "Ocultar todos",
        verGeocercas: "Ver geocercas",
        ocultarGeocercas: "Ocultar geocercas",
        agregarUbicacion: "Agregar ubicación",
        configDispositivos: "Configuraciones de dispositivo",
        verConfiguracion: "Ver configuración",
        restablecer: "Restablecer",
        filtro: "Filtro",
        ocultarFiltro: "Ocultar filtro",
        velocidad: "Velocidad",
        nudos: "Nudos",
        bateria: "Batería",
        angulo: "Ángulo",
        distancia: "Distancia:",
        geocercaMoni: "geocerca",
        estadia: "Tiempo estadía",
        actualizacion: "Hora última actualización",
        sinActividad: "Tiempo fuera línea",
        msgConfguraciones: "El dispositivo {0} no tiene configuraciones, ¿Desea configurar?",
        dispRedonda: "Buscar dispositivos a la redonda",
        ocultarDispRedonda: "Ocultar dispositivos a la redonda",
        unidadLong: "Seleccione el tipo de medida",
        metros: "Metros",
        km: "Kilometros",
        lblNumGeocercas: "El dispositivo {0} {1}",
        lblAuxNumGeo: "{0} cuenta con {1} ",
        posActual: "Posición actual",
        presMetros: "Precisión en metros",
        ubicacion: "Ubicación",
        tiempoEsta: "Tiempo de estadía",
        areas: "Áreas",
        habilitarUbicacion: "Habilitar ubicación",
        deshabilitarUbicacion: "Deshabilitar ubicación",
 
        //Alertas
        alertas: "Alertas",
        todas: "Todas las alertas",
        configuracion: "Configuración",
        bateriaBaja: 'Batería baja',
        impacto: "Impacto",
        movimiento: "Movimiento",
        auxilio: "Auxilio",
        geocerca: "Geocerca",
        msgErrorPosAlerta: "Error al mostrar la posición de la alerta",

        //Modo abierto
        tModoAbierto: "Modo abierto (Rastreo limitado en un intervalo de tiempo)",
        horas: "Horas",
        minutos: "Minutos",
        segundos: "Segundos",
        intervalos: "Intervalos",
        msgTKSTAR: "Los dispositivos modelo TKSTAR no cuentan con un comando homologo "+
                    "como los dispositivos COBAN(TK108), por lo que no se puede obtener "+
                    "la ubicación actual del dispositivo en la cantidad indicada de intervalos "+
                    "de tiempo. Se consultará la ubicación real del dispositivo cada vez que "+
                    "se haga clic en el botón Enviar.",
        msgConfiReset: "¿Está seguro que desea reiniciar de fábrica? Todas las configuraciones serán reiniciadas.",
        msgElimUbic: "¿Está seguro que desea eliminar la ubicación?",

        //Dispositivos a la redonda
        popupDistancia: "Distancia entre el dispositivo {0}",

        //Mensajes modal
        msgActUbic: "Ubicación actualizada exitosamente.",
        msgErrActuUbic: "Error al actualizar la ubicación.",
        msgRegUbic: "Ubicación registrada exitosamente.",
        msgIniciarSesion: "Iniciar sesión.",
        msgErrRegUbic: "Error al agregar la ubicación.",
        msgErrBuscarUsu: "Error al buscar usuarios.",
        msgUsuarioSinDispositivos: "Usuario no cuenta con dispositivos asignados.",
        msgErrBuscarDispositivos: "Error al buscar dispositivos.",
        msgSinUbicaciones: "No cuenta con ubicaciones guardadas.",
        msgUbicacionEliminada: "Ubicación eliminada exitosamente.",
        msgErrEliminarUbicacion: "Error al eliminar la ubicación.",
        msgSolicitudRastreo: "Respuesta recibida solicitud de rastreo.",
        msgVerDispo: "Dispositivo seleccionado no cuenta con posiciones.",
        msgIntervalo: "El intervalo de tiempo debe ser mayor a 20 segundos.",
        msgSoliRastreo: "Solicitud de rastreo enviada con éxito.",
        msgErrComandArduino: "Error al enviar el comando revisar la conexión con el arduino.",
        msgPosRegExitosa: "Posición registrada exitosamente.",
        msgPosRegError: "La posición no fue registrada.",
        msgSinGeocercas: "El dispositivo no cuenta con geocercas.",
        msgReset: "Reinicio de fábrica",
        msgErrReset: "Error al enviar la solicitud de reinicio de fábrica.",
        msgTiempoResp: "La respuesta puede tardar unos segundos.",
        msgSinDispositivos: "No cuenta con dispositivos asignados.",
        msgUbicTiempoReal: "Ubicación en tiempo real cargada exitosamente.",
        msgUbicTiempoDesc: "Ubicación en tiempo real desactivada.",
        msgRedonda: "Consulta de dispositivos a la redonda para el dispositivo",
        msgDescRedonda: `<li>Si la geocerca mostrada es color <font color="green"><strong><u>verde</u></strong></font>, significa que no se encontraron dispositivos próximos en el radio de búsqueda.</li><li>Si la geocerca mostrada es color <font color="red"><strong><u>rojo</u></strong></font>, significa que se encontraron dispositivos próximos en el radio de búsqueda.</li>`,
        msgErrorDispRedonda: 'No es posible buscar dispositivos a la redonda ya que el dispositivo seleccionado no cuenta con posiciones.',
        noDispoAlertas: "No cuenta con dispositivos asignados para consultar sus alertas.",
        alertasEncontradas:"Alertas encontradas en el rango de fechas seleccionado.",
        alertasNoEncontradas:"No cuenta con alertas dentro del rango de fechas.",
        msgHabilitarUbicacion: "Error al habilitar la ubicación en tiempo real."
      },


      configDispositivos:{
        deshabilitado: "Deshabilitado",
        modo: "Modo",
        rastreador: "Rastreador activado",
        microfono: "Micrófono activado",
        alarmaImpacto: "Alarma de impacto",
        activa: "Activa",
        alertaVelocidad: "Alerta de velocidad",
        bateriaBaja: "Batería baja",
        zonaHoraria: "Zona horaria",
        distanciaRastreo: "Distancia de rastreo inteligente",
        metros: "metros",
        radioMovimiento: "Radio de movimiento",
        cambioDireccion: "Cambio de dirección",
        grados: "grados",
        nivelSensibilidad: "Nivel de sensibilidad",
        primerNivel: "Primer nivel: Vibración leve una vez",
        segundoNivel: "Segundo nivel: Detectar 8 veces la vibración",
        tercerNivel: "Tercer nivel: Detectar 25 veces la vibración",
        perEstatico: "Periodo estático",
        horarioTrabajo: "Horario de trabajo",
        horas: "horas",
        horasM: "Horas",
        minutos: "minutos",
        minutosM: "Minutos",
        dias: "días",
        diasM: "Días",
        segundos: "segundos",
        segundosM: "Segundos",
        configStopGo: "Configuración Stop and go",
        periodoMovimiento: "Período en movimiento",
        numAdministradores: "Números administradores",
        numSOS: "Número SOS",
        configurar: "Configurar",
        msgReinicio: "Se reiniciaron las configuraciones.",
        msgErrActConfig: "Error al actualizar la configuración.",
        msgCancelarEnvio: "Cancelar el envió de ubicaciones.",
        msgRespuesta: "Respuesta recibida exitosamente.",
        msgConfigExito: "Configuración actualizada exitosamente.",
        msgComandos: "Comandos enviados.",
        msgSolicitudEstatus: "Solicitud de estatus enviada con éxito.",
        msgRespuestaSolicitud: "Respuesta recibida solicitud de estatus.",
        msgErroEstatus: "Error al enviar la solicitud de estatus.",


        //Agregar ubicación
        insAgrUbic: "Instrucciones: Clic sobre el botón ",
        dibujarMarcador: "Dibujar un marcador",
        insAgrUbicA: " situado en el mapa representado con el icono",
        insAgrUbicB: "Hacer clic sobre el mapa para colocar el marcador, " + 
                     "posteriormente ingrese el nombre del marcador en el formulario.",
        guardarUbicacion : "Guardar ubicación",

        //Editar ubicación
        editarUbicacion: "Editar ubicación",
        instruccionEditar: "Instrucciones para editar la ubicación del marcador:",
        insMarcA: "Hacer clic sobre el botón ",
        insMarcB: " situado en el mapa representado con el icono ",
        insMarcC: "Arrastrar el marcador a la ubicación deseada y hacer " +
                  "clic sobre el botón guardar situado sobre el mapa.",
        insEditarUbicacionA: "Modificar el {0} de la ubicación y " +
                              "las coordenadas de los campos {1} / {2}.",
        ocultar: "Ocultar",
        modoAbierto: "Modo abierto",
        cerrarModoAbierto: "Cerrar modo abierto",
        ubicacionesGuardadas : "Ubicaciones guardadas",

        //Configuración de dispositivo TK108
        msgConfigDisp: "Configuración de alarmas dispositivo {0} , modelo {1}",
        noAsignado: "No asignado",
        //
        modoMixto: "Modo mixto:",
        msgMixto: "Permite rastrear con tiempos ilimitados en un intervalo de tiempo.",
        msgModalMixto: "Rastreo sin límites por intervalos de tiempo",
        lblMovMixto: "Período de tiempo en movimiento* :",
        lblEstMixto: "Período de tiempo estático* :",
        medidaTiempo: "Seleccionar medida de tiempo",
        
        //
        modoStopGo: "Modo stop and go:",
        msgStopGo: "Configuraciones que permiten el ahorro de batería.",
        msgTextStop: "<strong>No apagado:</strong> El GPS funcionará normalmente sin apagarse y reportará normalmente.<br><br>" +
                    "{0}" +
                    "<strong>Apagado por sensor de impacto:</strong> Si no se detecta un golpe y el vehículo se encuentra apagado, " +
                    "entrará en modo reposo. Cualquier golpe o movimiento enciende de nuevo el GPS.<br><br>" +
                    "<strong>Dormir por tiempo:</strong> En caso de que el dispositivo no cuente con alarmas activadas y no se " +
                    "encuentre en movimiento este se apagará en 5 minutos. Las llamadas o SMS activaran el GPS.",
        msgApagadoProf: "<strong>Apagado profundo por sensor de impacto:</strong> Si no se detecta vibración entra en modo suspensión " + 
                    "profunda. El modulo GPS Y GSM se apagan, entra en el modo de consumo de batería mas bajo.<br><br>",
        msgModalStop: "Apagado del dispositivo",
        noApagado: "No apagado",
        apagadoProf: "Apagado profundo por sensor de impacto",
        apagadoImp: "Apagado por el sensor de impacto",
        dormirTiempo: "Dormir por tiempo",
        msgApagEnc: "No Apagado/Encendido.",
        msgSelecApagado: "Seleccione un tipo de apagado",


        //Modo velocidad
        msgAlarma: "Alarma de exceso de velocidad",
        msgTextAlarma: "Alerta cuando se excede un límite de velocidad establecido.",
        lblVelocidad: "Ingresar la velocidad (Km/h )* :",
        msgVelocidad: "Alarma de velocidad activada.",
        msgVelocidadDes: "Alarma de velocidad desactivada.",

        //Modo cambiar dirección
        modoCambDir: "Cambio de dirección:",
        msgCambDir: "Actualización automática de cambio de dirección.",
        msgTextCabDir: "El GPS actualizará las posiciones automáticamente una vez el vehículo cambie la dirección de conducción por encima del valor preestablecido del ángulo para formar una trayectoria suave consistente con el cambio.",
        msgDireccion: "Cambio de dirección activado.",

        //Modo movimiento
        msgAlarMov: "Alarma de movimiento",
        msgTextAlarMov: "Activa una alerta de movimiento cuando la unidad permanece inmóvil de 3 a 10 minutos y se mueve en el radio predeterminado.", 
        lblIngRadio: "Ingresar radio en metros* :",
        msgMovimiento: "Alarma movimiento activada.",
        msgMovimientoDes: "Alarma movimiento desactivada.",

        //Modo Horario de trabajo
        modoTrabajo: "Trabajar en horario específico",
        lblDes: "desactivado",
        msgTextTrabajo: "El GPS solo se encenderá cada determinado tiempo que programemos y reportará la ubicación.",
        lblTiempo: "Tiempo* :",

        //Modo zona horaria
        modoZona: "Configuración zona horaria y fecha",
        msgTextZona: "Seleccione la zona horaria que corresponda. <br><br>" +
                     "<strong>*</strong> Los estados de <ins><strong>Sonora</strong></ins> y <ins><strong>Quintana Roo</strong></ins> no participan en el programa del horario de verano.",
        zonaNoroeste: "Zona Noroeste",
        zonaPacifico: "Zona Pacífico",
        zonaSureste: "Zona Sureste",
        zonaCentro: "Zona Centro",
        lblZonaHor: "Zona horaria* :",
        lblZonaHoraria: "Seleccione una zona horaria",
        magCambioZona: "Cambio de zona horaria.",
        msgErrCambioZona: "Error al enviar la solicitud de cambio de zona horaria.",

        //Modo sensibilidad
        modoSens: "Configuración de sensibilidad",
        msgModalSens: "Configura la sensibilidad del sensor de impacto en tres niveles.",
        msgTextSens: "Configura la sensibilidad del sensor de impacto en tres niveles.<br><br>" + 
                     "<strong>Primer nivel:</strong> la alarma se disparará después de detectar una vibración leve una vez.<br><br>" + 
                     "<strong>Segundo nivel:</strong> la alarma se disparará al detectar 8 veces la vibración en 2 segundos.<br><br>" +
                     "<strong>Tercer nivel:</strong> la alarma se disparará después de detectar 25 veces la vibración en 5 segundos.",
        lblSens: "Nivel de sensibilidad* :",
        valPrimer: "Primer nivel: Vibración leve una vez",
        valSegundo: "Segundo nivel: Detectar 8 veces la vibración en 2 segundos",
        valTercero: "Tercer nivel: Detectar 25 veces la vibración en 5 segundos",
        msgSensibilidad: "Configuración de sensibilidad realizada con éxito.",

        //Modo Restreo Inteligente
        modoRastreoIntel: "Rastreo inteligente durante un intervalo de tiempo y distancia:",
        msgModalRastreo: "Rastreo durante un período de tiempo y distancia",
        msgTextRastreo: "Rastreo inteligente durante un intervalo de tiempo y distancia.",
        msgTextDesc: "El GPS informará una ubicación en tiempo real cada que recorra la distancia programada.",
        lblDis: "Distancia en metros* :",
        msgRastreo: "Modo rastreo activado.",
        msgConfiguracion: "Configuración de distancia activada.",
        msgRastreoDistancia: "Rastreo por distancia y tiempo.",

        //Modo bateria baja
        msgBateriaBaja:"Alarma que indica que la batería del dispositivo se encuentra en 20% o menos. {0}",
        msgCasoTK: "En el caso de los dispositivos modelo TKSTAR, esta configuración se encuentra activa por default y no es posible desactivarla.",
        msgBatBajaDes: "Alarma batería baja desactivada.",
        msgBatBaja: "Alarma batería baja activada.",

        //Modo Microfono
        modoRastreo: "Modo de rastreo micrófono/rastreador",
        msgHeadMicro: "Switch apagado: modo micrófono / Switch encendido: modo rastreo",
        msgHeadMicroTK: "Switch encendido modo rastreo",
        msgModalMicro: "Modo micrófono y modo rastreo",
        msgTextOnMicro: "<strong>Encender el micrófono:</strong> al llamar al GPS escuchará el audio del micrófono.",
        msgTextOffMicro: "<strong>Modo rastreo:</strong> dejará de escuchar el audio del micrófono, y recibirá la ubicación del GPS.",
        msgRastreoTK: "<strong>Modo rastreo:</strong> El dispositivo recibirá la ubicación del GPS.",
        msgMicrofono: "Modo micrófono activado.",

        //Modo impacto
        modoAlarma: "Alarma por impacto",
        msgAlarImpact: "Activa una alerta cuando el GPS se mueve, se inclina, o se golpea.",
        msgAlerta: "Alerta de impacto activada.",
        msgAlertaDes: "Alarma de impacto desactivado.",


        //Modo administrador
        modoConfAdmin: "Configuración de administrador:",
        msgModalAdmin: "Configuración de autorización",
        msgTextAdmin: "Permite configurar y autorizar un número celular como administrador o retirar dichos privilegios.",
        msgAdmin: "Administrador agregado.",
        msgEliminarAdmin: "Administrador eliminado correctamente.",
        msgAddAdmin: "Administrador agregado con éxito.",
        msgDelAdmin: "Administrador eliminado con éxito.",
        msgErrSolicitud: "Error al enviar la solicitud de administrador.",
        msgTelValido: "Ingrese un teléfono válido.",
        msgAddTel: "Ingrese un número de teléfono.",
        msgElimAdmin: "Eliminar administrador.",
        msgErrDelAdmin: "Error al enviar la solicitud de eliminar admininistrador.",

        //Modo SOS
        lblSOS: "Configuración de SOS",
        msgConfigSOS: "Permite configurar y autorizar un número celular como SOS.",
        msgSOS: "Permite configurar y autorizar un número celular como SOS o retirar dichos privilegios. <br><br>" +
                "Únicamente puede haber un número SOS, que es el que va a recibir las notificaciones SMS de las alarmas.",
        msgSOSAgregado: "SOS agregado",
        msgSOSDel: "SOS eliminado correctamente.",
        msgErrActualizar: "Error al actualizar la configuración de SOS",
        msgSOSAdd: "SOS agregado con éxito.",
        msgErrSentSolicitud: "Error al enviar la solicitud de SOS.",
        msgDelSOS: "Eliminar SOS.",
        msgErrSolDelSOS: "Error al enviar la solicitud de eliminar SOS.",

        //Modo estatus de dispositivo
        modoEstatus: "Estatus del dispositivo",
        msgTextEstatus: "Permite consultar el estado actual del dispositivo. Active el interruptor y haga clic sobre el " +
                        "botón <strong>Enviar</strong> para enviar la solicitud al dispositivo. Espere unos segundo y verá " +
                        "el estatus del dispositivo en el campo <strong>Respuesta</strong>.",
        msgModalEstatus: "Permite consultar el estado actual del dispositivo.",
      },


      //Diccionario de traducciones para la vista Dispositivos
      vDispositivos:{
        sinUsuarios: "Sin usuarios",
        generarLink: "Generar link",
        copiarLink: "Copiar link",
        noPermisos: "No tienes permisos para ver esta pantalla",
        modelCompat:"Los modelos compatibles son:",
        y: "y",
        eliminarDispo: "¿Está seguro que desea eliminar el dispositivo?",
        msgDelDispo: "Dispositivo eliminado exitosamente.",
        msgErrDelDispo: "Dispositivo no puede eliminarse porque contiene uno o más usuarios asignados.",
        errDelDispo: "Error al eliminar dispositivo.",
        msgIngresarN: "Ingrese el nombre",
        msgPass: "Contraseña",
        msgIngresePass: "Ingrese la contraseña de 6 dígitos",
        msgFormatPass: "Formato de contraseña correcto.",
        msgSelecModelo: "Seleccione un modelo",
        msgFormatTel: "Formato de teléfono correcto.",
        msgFormatValido: "Formato correcto.",
        msgGrupo: "Grupo",
        msgSelecGrupo: "Seleccione el grupo",
        msgAsigUsers: "Asignar usuario(s)",
        msgSaveDispo: "Guardar dispositivo",
        msgDato: "Dato dependiente del modelo* :",
        msgId: "Ingrese ID de 10 dígitos.",
        msgImei: "Ingrese IMEI de 15 dígitos.",
        msgDispoReg: "Dispositivo registrado exitosamente.",
        msgDispoConf: "Dispositivo configurado exitosamente.",
        msgErroConfigDis: "Error al configurar el dispositivo.",
        msgSinConfig: "No cuenta con configuraciones, dispositivo no configurado.",
        msgImeiExiste: "IMEI registrado anteriormente, intente con uno diferente.",
        msgSerialExiste:"Serial registrado anteriormente, intente con uno diferente.",
        msgDigitosSerial: " El serial debe tener 9 dígitos.",
        msgDigitosImei: "El IMEI debe tener 15 dígitos.",
        msgImeiDel: "IMEI registrado y eliminado anteriormente, contacte al administrador.",
        msgTelExiste: "Telefóno registrado anteriormente, intente con uno diferente.",
        msgErrorDispo: "Error al registrar dispositivo.",
        msgConfigDispo: "Configurando dispositivo...",
        msgTxtDispoLink: "Genere un link para compartir la ubicación en tiempo real del dispositivo {0}",
        msgTxtTiempoLink: "Seleccione la opción de tiempo para compartir link",
        msgTxtLinkGenerado: "Aquí aparecerá el link generado",
        msgLinkGenerado: "Link generado exitosamente.",
        msgErrGenerarLink: "Error al generar link.",
        msgCadLink: "Se ha caducado el link de acceso anterior.",
        msgPorta: "Se ha copiado el link al portapapeles.",
        msgErrPorta: "No se pudo copiar el link al portapapeles.",
        msgDeviceUpdate: "Dispositivo actualizado exitosamente",
        msgNoPosicionesLink: "No hay posiciones registradas en el último mes para el dispositivo, ¿Deseas continuar?",
        msgNoDispositivoModelo: "El dispositivo no tiene un modelo asignado",
        msgActualizarDispositivo: "Actualizando y configurando el dispositvo GPS",
        agregarDispositivoGral: "Agregar dispositivo general",
        agregarDispositivoInst: "Agregar dispositivo institucional",
        dispositivoInstitucional: "Dispositivo institucional",
        dispositivoComercial: "Dispositivo comercial",
        tipoDispositivo: "Tipo de dispositivo",
        seleccioneDispositivo: "Seleccione el tipo de dispositivo",
        msgErrorActualizarDispositivo: "Error al actualizar el dispositivo."
      },

      //Diccionario de traducciones para la vista Geocercas
      vGeocercas:{
        geocerca: "Geocerca",
        agregarGeocercas: "Agregar geocercas",
        noDispo: "Sin dispositivos",
        msgGeoEncontradas: "Geocercas encontradas.",
        msgGeoOcultas: "Se ocultaron las Geocercas.",
        dias: "Días",
        noAplica: 'No aplica',
        erroBuscar: "Error al buscar las geocercas.",
        eliminarGeo: "¿Está seguro que desea eliminar la geocerca?",
        msgDelGeocerca: "Geocerca eliminada exitosamente.",
        errDelGeocerca: "Error al eliminar la geocerca.",

        //Agregar Geocercas
        verForm: "Ver formulario",
        lblAsigDispo: "Asignar dispositivo",
        saveGeocercas: "Guardar geocerca",
        selectAlert: "Seleccione una alerta",
        selectMedida: "Seleccione una medida",
        metros: "Metros",
        km: "Kilometros",
        entrada: "Entrada",
        salida: "Salida",
        ambos: "Ambos",
        msgErrDibGeos: "* Solo puede dibujar una geocerca.",
        msgGeoRegistrada: "Geocerca registrada exitosamente.",
        msgErrGeoReg: "La geocerca no fue registrada.",
        msgIngreseGeo: "Ingrese el nombre de la geocerca",
        msgIngreseRadio: "Ingrese el radio",
        msgIngreseLat: "Ingrese la latitud",
        msgIngreseLon: "Ingrese la longitud",

        //Editar Geocercas
        msgActgeo: "Geocerca actualizada exitosamente.",
        msgErrGeoAct: "La geocerca no fue actualizada.",

      },

      vEstadisticas:{
        tipoBusqueda: "Tipo de búsqueda",
        alertasDiarias: "Alertas diarias",
        ultimas: "Últimas 24 hrs",
        fechas: "Por rango de fechas",
        noAlertas: "No se reportaron alertas en las últimas 24 hrs.",
        noAlertasByDates: "No se reportaron alertas del {0} al {1}",
        msgSelectDispo: "Seleccione un dispositivo y fecha(s) para comenzar a ver sus estadísticas.",
        tAtencion: "¡Atención!",
        txtAtencion: "No se han registrado alertas en las últimas 24 hrs. Sin embargo puede realizar una búsqueda a partir de un rango de fechas.",
        msgInterceptadas: "Geocercas interceptadas en las últimas 24 hrs",
        tipoGeocerca: "Tipos de geocercas",
        numeroGeocerca: "Número de geocercas",
        alertasFecha:"Alertas por rango de fechas",
        geocercaEntrada: "Geocerca de entrada",
        geocercaSalida: "Geocerca de salida",
        msgNoDispositivo: "No se encontraron resgistros para este dispositivo",
        msgNoGeocercasPorFecha: "No se encontraron geocercas del {0} al {1}",
        msgErrorVerActividad: "Para poder ver un resumen de la actividad de los dispositivos, es necesario que cuente con al menos un dispositivo."
      },
      //Diccionario de traducciones para la vista de usuarios
      vUsuarios:{
        agregarUsuario: "Agregar usuario",
        restablecerPass: "Restablecer contraseña",
        habUser: "¿Está seguro que desea {0}abilitar el usuario?",
        msgHabUser: "Usuario {0}abilitado exitosamente.",
        msgContrasena: "¿Está seguro que desea asignar una contraseña temporal? El usuario deberá asignar una contraseña nueva al iniciar sesión.",
        msgAsignarContra: "La contraseña temporal es",
        msgErrorContrasena: "Error al resetear contraseña.",
        msgVerUsuario: "¿Está seguro que desea ver el espacio de trabajo del {0} {1}?",
        lblAddUser: "Introduce el usuario",
        lblSelecRol: "Seleccione el rol",
        rol: "Rol",
        lblAddPass: "Introduce una contraseña",
        msgIntroPass: "Por favor introduce una contraseña",
        msgErroPass:"Tu contraseña debe estar compuesta por al menos 3 palabras separadas por espacios de al menos 12 caracteres en total",
        confirPass: "Confirmación contraseña",
        lblConfirPass: "Confirma tu contraseña",
        msgConfirPass: "Confirmación de contraseña debe ser exactamente igual a contraseña",
        saveUser: "Guardar usuario",
        userReg: "Usuario registrado exitosamente.",
        userErr1: "Nombre de usuario registrado anteriormente, intente con uno diferente.",
        msgErrRegUser:"Error al registrar usuario.",
        msgNombreUser: "Ingrese el nombre del usuario",
        msgUserAct: "Usuario actualizado correctamente.",
        usuarioAdministrador: "Usuario administrador",
        selecUsuarioAdministrador: "Seleccione el usuario administrador"
      },


      //Diccionario de traducciones para la vista grupos
      vGrupos:{
        agregarGrupo: "Agregar grupo",
        guardarGrupo: "Guardar grupo",
        editarGrupo: "Editar grupo", 
        msgHabilitar: "¿Está seguro que desea {frase}abilitar el grupo?",
        msgHabilitarToast: "El grupo fue {frase}abilitado exitosamente.",
        msgRegistro: "Grupo registrado exitosamente.",
        msgRegistroError: "El grupo no pudo ser registrado.",
        msgActualizarError: "Error al actualizar el grupo",
        msgErrorBuscar: "Error al buscar los grupos.",
        msgActualizar: "Grupo actualizado exitosamente.",
        msgErrorActualizar: "El grupo no pudo ser actualizado.",
        msgErrorHabilitar: "Error al {0}abilitar el grupo.",
        msgErrorGrupo: "Ingrese el nombre del grupo",
        msgErrorNombreGrupo: "El nombre ingresado ya está en uso. Por favor, ingrese un nombre diferente.",
        numeroDispositivos: "Número de dispositivos",
        usuariosFinales: "Usuarios finales",
        usuariosAdmin: "Usuarios administradores",
      },

      vBitacora:{
        filtrado: "Selecciona un tipo de filtrado",
        consultar: "Consultar",
        filtroCompleto: "Historial completo",
        filtroAcciones: "Historial de acciones",
        filtroConfiguracion: "Historial de configuración",
        msgErrorCargar: "Error al cargar bitácora.",
        msgBitacoraVacia: "No se encontró log de acciones.",
        msgCargarHistorial: "Historial cargado exitosamente.",
        msgSinRegistros: "No hay historial en rango de fechas seleccionado.",
        presioneAgregar: "Presione para agregar",
        seleccionado: "Seleccionado",
        presioneEliminar: "Presione para remover",

      },
      
      vConfiguraciones:{
        ip: "IP del servidor",
        msgIp: "Ingrese una ip válida.",
        numeroArduino: "Número telefónico del Arduino",
        msgNumero: "Ingrese teléfono de 10 dígitos.",
        msgRadio: "Radio para almacenar las posiciones estáticas (metros)",
        puertoTK108: "Puerto del servidor para dispositivos COBAN",
        msgPuerto: "Ingrese un puerto válido.",
        puertoTKSTART: "Puerto del servidor para dispositivos TKSTAR",
        apn: "Compañía telefónica (APN)",
        ejemplo: "Ejemplo: ",
        msgErrorConfig: "Error al buscar las configuraciones.",
        msgActualizarConfig: "Configuraciones actualizadas exitosamente.",
        msgErrActualizar: "Las configuraciones no fueron actualizadas.",
        msgRegConfig: "Configuraciones registradas exitosamente.",
        msgErrRegConfig: "Las configuraciones no fueron registradas.",
        intervaloAlerta: "Intervalo tiempo actualización alertas.",
        intervaloDispositivo: "Intervalo tiempo actualización dispositivos",
        segundos: "Segundos",
        puertoBack: "Puerto del Backend"

      },

      vHistorico:{
        presioneAgregar: "Presione para agregar",
        seleccionado: "Seleccionado",
        presioneEliminar: "Presione para remover",
        selecDispo: "Seleccione un dispositivo",
        msgBusquedaFallida: "No se encontraron elementos que coincidan con la búsqueda.",
        descargarExcel: "Descargar historial en Excel",
        descargarCSV: "Descargar historial en CSV",
        marcaInicio: "Inicio",
        marcaFinal: "Final",
        // irFinal: "Ir al final",
        msgErrCargarPos: "Error al cargar posiciones.",
        msgSinPos: "No hay posiciones entre el rango de fechas.",
        msgNoPosiciones: "El dispositivo no cuenta con posiciones registradas.",
        msgModalNoDispo: "Para realizar una búsqueda de historial es necesario que cuente con al menos un dispositivo.",
        msgErrorBuscarDispo: "Error al buscar dispositivos.",
        msgErrorExportar: "Error al exportar historial.",
        lblResultados: "El dispositivo cuenta con {0} posiciones.",
        msgPosCargadas: "Posiciones cargadas exitosamente.",
        msgErrorAlertas: "Error al cargar alertas.",
        msgSinAlertas: "No hay alertas entre el rango de fechas.",
        msgErrorArchivo: "Error al exportar archivo.",
        mssgSelectCodigoPais: "Seleccione el codigo de un país",
      },

      //Tablas
      dispositivos: "Dispositivos",
      "Modo abierto": "Modo abierto",
      "Configuracion": "configuracion",
    },

    //Diccionario en idioma inglés 
    en: {
      tableHeaders: {
        idEquipo: "Team Identifier",
        modelo: "Model",
        imei: "IMEI/Id",
        telefono: "Phone",
        usuarios: "Users",
        grupo: "Group",
        acciones: "Actions",
        registros: "Actions registered",
        fechaRegistro: "Date of registration",
        nombre: "Name",
        alerta: "Alert",
        usuario: "User",
        dispositivos: "Devices",
        rol: "Role",
        tipo: "Type",
        comercial: "Commercial",
        institucional: "Institutional",
        informacion: "General information",
      },

      //Para nombre de label en tablas
      headerGeneralMovil:{
        usuario: "User",
        rol: "Role",
        grupo: "Group",
        accion: "Action",
        fecha: "Date created",
        modelo: "Model",
        marca: "Brand",
        acciones: "Actions",
        nombre: "Name",
        alerta: "Alert",
        dispositivo: "Device",
        telefono: "Phone"
      },

      Starter: "Starter",
      "Monitoreo": "Monitoring",
      "Dispositivos": "Devices",
      "agregarDispositivo": "Add device",
      "TK108": "COBAN device configuration",
      "TKSTAR": "TKSTAR device configuration",
      "Histórico": "History",
      "Geocercas": "Geofences",
      "AddGeocercas": "Add geofence",
      "EditGeo": "Edit geofence",
      "Estadísticas" : "Statistics",
      "Usuarios": "Users",
      "Grupos":"Groups",
      "Bitácora": "Logbook",
      "Configuraciones":"Settings",
      "Agregar dispositivo": "Add device",
      "Editar dispositivo": "Edit device",
      "Agregar geocerca": "Add geofence",
      "Editar geocerca": "Edit geofence",
      "Agregar usuario": "Add user",
      "Editar usuario": "Edit user",
      "Marcas": "Brands",
      "Agregar marca": "Add brand",
      "Editar marca": "Edit brand",
      "Modelos": "Models",
      "Agregar modelo": "Add model",
      "Editar modelo": "Edit model",
      "Menú": "Menu",
      
      Gral:{
        agregar: "Add",
        cancelar : "Cancel",
        noRegistros: "No records were found.",
        busquedaFallida:"No results were found for your search.",
        ver: "View",
        editar: "Edit",
        hoy: "Today",
        latitud: "Latitude",
        longitud: "Longitude",
        radio: "Radius",
        nombre: "Name",
        acciones: "Actions",
        camposObligatorios: "Required fields",
        eliminar: "Delete",
        tipo: "Type",
        dispositivo: "Device",
        sinSeleccionar: "unselected",
        seleccionar: "Select",
        modelo: "Model",
        enviar: "Send",
        respuesta: "Response",
        alerta: "Alert",
        aceptar: "Accept",
        usuario: "User",
        guardar: "Save",
        cerrar: "Close",
        h: "en",
        des: "dis",
        abilitado: "abled",
        tel: "Telephone* :",
        valExitTelefono: "Enter 10-digit phone number.",
        medida: "Length",
        imgLeyenda:"/assets/img/marcadores-ingles.svg",
        buscar: "Search",
        limpiarBusqueda: "Clear search",
        habilitar: "Enable",
        deshabilitar: "Disable",
        rangoFechas: "Range of dates",
        seleccionarFecha: "Select a date range",
        escribaBuscar: "Type to search",
        guardarCont: "Save and continue",
        agregarDispo: "Add device",
        msgSesionCaducada: "Session closed for inactivity.",
        msgEspere: "Please wait ...",
        msgSesion: "Log in to your account",
        msgErrorDesconocido: "Unknown error",
        verUsuarios: "View users",
      },

      Mapa:{
        zoomInTitle: 'Zoom in',
        zoomOutTitle: 'Zoom out',
        screenFullTitle: 'View fullscreen',
        screenExitTitle: 'Exit fullscreen',
        titleDraw: 'Measure distance(s)',
      },

      //Generales
      monitoreo: "Monitoring",
      notificaciones : "Notifications",
      sinNotificaciones: "No notifications",
      vistaMaster: "Back to master view",
      notifSonoras: "Sonorous notifications",
      notifTiempoReal: "Real time location",
      temaOscuro: "Dark theme",
      idioma: "Switch to Spanish",
      cerarSesion: "Sign out",
      vistaMasterQ: "Are you sure you want to return to the Master view?",
      popAlarmaSonora: "Sonorous alarm {frase}abled.",
      popUbicacion: "Real time location {frase}abled.",
      poptemaOscuro: "Dark theme {frase}abled.",
      popIdioma: "Now use the English system",
      textoAyuda: "Help",

      vModelo:{
        modelo: "Model",
        agregarModelo: "Add model",
        guardarModelo: "Save model",
        elejirModelo: "Select model",
        msgModelo: "The model name must be at least 5 characters long",
        msgHabilitar: "Are you sure you want to {frase}able the model?",
        msgHabilitarToast: "The model was successfully {frase}abled.",
        msgRegistro: "Model successfully registered.",
        msgErrorModelo: "Error registering the model.",
        msgActualizar: "Successfully updated model.",
        msgErrorActualizarModelo: "Error updating the model.",
        editarModelo: "Edit model",
      },

      vMarca:{
        marca: "Brand",
        agregarMarca: "Add brand",
        editarMarca: "Edit brand",
        elejirMarca: "Select brand",
        msgHabilitar: "Are you sure you want to {frase}able the brand?",
        msgHabilitarToast: "The brand was successfully {frase}abled.",
        msgRegistro: "Brand successfully registered.",
        msgErrorMarca: "Error registering the brand.",
        msgActualizar: "Successfully updated brand.",
        msgErrorActualizarMarca: "Error updating the brand.",
        msgMarca: "The brand name must be at least 4 characters long",
        msgErrorActualizar: "Error updating status"
      },

      categoriaAlertas: {
        bateriaBaja: 'Low battery',
        impacto: "Impact",
        movimiento: "Movement",
        auxilio: "Hazzard",
        geocerca: "Geofence",
        velocidad: "Speed",
      },

      // ============ Monitoreo ============ //
      vMonitoreo:{
        dispositivosUbic:"Devices and locations",
        listadoAlertas: "Alerts list",
        verTodos: "View all",
        ocultarTodos: "Hide all",
        verGeocercas: "View geofences",
        ocultarGeocercas: "Hide geofences",
        agregarUbicacion: "Add location",
        configDispositivos: "Device configurations",
        verConfiguracion: "View configuration",
        restablecer: "Reset",
        filtro: "Filter",
        ocultarFiltro: "Hide filter",
        velocidad: "Speed",
        nudos: "Knots",
        bateria: "Battery",
        angulo: "Angle",
        distancia: "Distance:",
        geocercaMoni: "geofence",
        estadia: "Time of stay",
        actualizacion: "Last update",
        sinActividad: "Offline time",
        msgConfguraciones: "The {0} device has no settings, do you want to configure?",
        dispRedonda: "Search for devices around",
        ocultarDispRedonda: "Hide devices around",
        unidadLong: "Select length type",
        metros: "Meters",
        km: "Kilometers",
        lblNumGeocercas: "The {0} device {1}",
        lblAuxNumGeo: "has {0} {1}",
        posActual: "Current position",
        presMetros: "Meter accuracy",
        ubicacion: "Location",
        tiempoEsta: "Time of stay",
        areas: "Areas",
        deshabilitarUbicacion: "Disable location",
        habilitarUbicacion: "Enable location",
        
        //Alertas
        alertas: "Alerts",
        todas: "All alerts",
        bateriaBaja: 'Low battery',
        configuracion: "Setting",
        impacto: "Impact",
        movimiento: "Movement",
        auxilio: "Hazzard",
        geocerca: "Geofence",

        //Modo abierto
        tModoAbierto: "Open mode (limited tracking in a time interval)",
        horas: "Hours",
        minutos: "Minutes",
        segundos: "Seconds",
        intervalos: "Intervals",
        msgTKSTAR: "TKSTAR model devices do not have a homologous command like COBAN(TK108) "+
                   "devices, so the current location of the device cannot be obtained in "+
                   "the specified number of time intervals. The actual location of the "+
                   "device will be queried each time the Submit button is clicked.",
        msgConfiReset: "Are you sure you want to factory reset? All settings will be reset.",
        msgElimUbic: "Are you sure you want to delete the location?",

        //Dispositivos a la redonda
        popupDistancia: "Distance between {0} device",

        //Modal Messages
        msgActUbic: "Location updated successfully.",
        msgErrActuUbic: "Error updating location.",
        msgRegUbic: "Location successfully registered.",
        msgIniciarSesion: "Log in.",
        msgErrRegUbic: "Error adding location.",
        msgErrBuscarUsu: "Error searching for users.",
        msgUsuarioSinDispositivos: "User has no assigned devices.",
        msgErrBuscarDispositivos: "Error searching for devices.",
        msgSinUbicaciones: "No saved locations.",
        msgUbicacionEliminada: "Location removed successfully.",
        msgErrEliminarUbicacion: "Error when deleting location.",
        msgSolicitudRastreo: "Response received tracing request.",
        msgVerDispo: "Selected device has no positions.",
        msgIntervalo: "The time interval must be greater than 20 seconds.",
        msgSoliRastreo: "Tracking request sent successfully.",
        msgErrComandArduino: "Error when sending the command to check the connection with arduino.",
        msgPosRegExitosa: "Position registered successfully.",
        msgPosRegError: "The position was not registered.",
        msgSinGeocercas: "The device does not have geofences.",
        msgReset: "Factory reset",
        msgErrReset: "Error when sending factory reset request.",
        msgTiempoResp: "The response may take a few seconds.",
        msgSinDispositivos: "There are no assigned devices.",
        msgUbicTiempoReal: "Real-time location uploaded successfully.",
        msgUbicTiempoDesc: "Real-time location disabled.",
        msgRedonda: "Query for nearby devices for the device",

        // msgDescRedonda: `<li>Si la geocerca mostrada es color <font color="green"><strong><u>verde</u></strong></font>, significa que no se encontraron dispositivos próximos en el radio de búsqueda.</li><li>Si la geocerca mostrada es color <font color="red"><strong><u>rojo</u></strong></font>, significa que se encontraron dispositivos próximos en el radio de búsqueda.</li>`,


        msgDescRedonda: `<li>If the displayed geofence is <font color="green"><strong><u>green</u></strong></font>, it means that no nearby devices were found within the search radius.</li><li>If the displayed geofence is <font color="red"><strong><u>red</u></strong></font>, it means that nearby devices were found within the search radius.</li>`,
        msgErrorDispRedonda: 'It is not possible to search for devices around because the selected device has no positions.',
        noDispoAlertas: "You do not have assigned devices to consult your alerts.",
        alertasEncontradas: "Alerts found in selected date range.",
        alertasNoEncontradas: "Does not have alerts within the date range.",
        msgHabilitarUbicacion: "Error enabling real-time location."
      },

      configDispositivos:{
        deshabilitado: "Disabled",
        modo: "Mode",
        rastreador: "Tracker enabled",
        microfono: "Microphone enabled",
        alarmaImpacto: "Crash alarm",
        activa: "Enable",
        alertaVelocidad: "Speed alert",
        bateriaBaja: "Low battery",
        zonaHoraria: "Time zone",
        distanciaRastreo: "Smart tracking distance",
        metros: "meters",
        radioMovimiento: "Radius of movement",
        cambioDireccion: "Address change",
        grados: "degrees",
        nivelSensibilidad: "Sensitivity level",
        primerNivel: "First level: Slight vibration once",
        segundoNivel: "Second level: Detect vibration 8 times",
        tercerNivel: "Third level: Detect vibration 25 times",
        perEstatico: "Static period",
        horarioTrabajo: "Work schedule",
        horas: "hours",
        horasM: "Hours",
        minutos: "minutes",
        minutosM: "Minutes",
        dias: "days",
        diasM: "Days",
        segundos: "seconds",
        segundosM: "Seconds",
        configStopGo: "Stop and go configuration",
        periodoMovimiento: "Period in motion",
        numAdministradores: "Administrator numbers",
        numSOS: "SOS number",
        configurar: "Setup",
        msgReinicio: "The configurations have been restarted.",
        msgErrActConfig: "Error updating the configuration.",
        msgCancelarEnvio: "Cancel sending of locations.",
        msgRespuesta: "Successfully received response.",
        msgConfigExito: "Configuration updated successfully.",
        msgComandos: "Commands sent.",
        msgSolicitudEstatus: "Status request successfully submitted.",
        msgRespuestaSolicitud: "Response received status request.",
        msgErroEstatus: "Error when sending the status request.",


        //Add location view
        insAgrUbic: "Instructions: Click on the button",
        dibujarMarcador: "Draw a marker",
        insAgrUbicA: "placed on the map represented by the icon",
        insAgrUbicB: "Click on the map to place the marker, enter the name of the marker in the form.",
        guardarUbicacion :"Save location",

        //Edit location view
        editarUbicacion: "Edit location",
        instruccionEditar: "Instructions to edit the marker location",
        insMarcA: "Click on the button",
        insMarcB: "located on the map represented by the icon",
        insMarcC: "Drag the marker to the desired location and click on the save button on the map.",
        insEditarUbicacionA: "Modify the {0} of the location and the coordinates of the {1} / {2} fields.",
        ocultar: "Hide",
        modoAbierto: "Open mode",
        cerrarModoAbierto: "Close open mode",
        ubicacionesGuardadas : "Saved locations",

        //Configuración de dispositivo TK108
        msgConfigDisp: "Configuration of alarms {0} device, model {1}",
        noAsignado: "Unassigned",
        //Modo Mixto
        modoMixto: "Mixed mode:",
        msgMixto: "Allows tracking with unlimited times in a time interval.",
        msgModalMixto: "Unlimited tracking by time intervals",
        lblMovMixto: "Period of time in movement* :",
        lblEstMixto: "Static time period* :",
        medidaTiempo: "Select time measurement",
        //Modo Stop and Go
        modoStopGo: "Stop and go mode:",
        msgStopGo: "Configurations that enable battery saving.",
        msgTextStop: "<strong>No shutdown:</strong> The GPS will operate normally without shutting down and will report normally.<br><br>" +
                     "{0}"+
                     "<strong>Shock sensor shutdown:</strong> If no shock is detected and the vehicle is off, it will go into sleep mode. " +
                     "Any shock or movement turns the GPS back on.<br><br>" +
                     "<strong>Sleep for time:</strong> In case the device does not have alarms activated and is not in motion, it will turn " +
                     "off in 5 minutes. Calls or SMS will activate the GPS.",
        msgApagadoProf: "<strong>Deep shutdown by shock sensor:</strong> If no vibration is detected, it enters deep sleep mode. GPS and GSM " +
        "module are turned off, it enters the lowest battery consumption mode.<br><br>",
        msgModalStop: "Device shutdown",
        noApagado: "Not turned off",
        apagadoProf: "Deep shutdown by shock sensor",
        apagadoImp: "Shock sensor shutdown",
        dormirTiempo: "Sleep for time",
        msgApagEnc: "No Power Off/On.",
        msgSelecApagado: "Select a shutdown type",

        //Modo velocidad
        msgAlarma: "Excess speed alarm",
        msgTextAlarma: "Alert when an established speed limit is exceeded.",
        lblVelocidad: "Enter speed (Km/h )* :",
        msgVelocidad: "Speed alarm enabled.",
        msgVelocidadDes: "Speed alarm disabled.",

        //Modo cambiar dirección
        modoCambDir: "Chance direction:",
        msgCambDir: "Automatic update of change of direction.",
        msgTextCabDir: "The GPS will update the positions automatically once the vehicle changes driving direction above the preset value of the angle to form a smooth trajectory consistent with the change.",
        msgDireccion: "Change of direction enabled.",

        //Modo movimiento
        msgAlarMov: "Movement alarm",
        msgTextAlarMov: "Activates a movement alert when the unit remains stationary for 3 to 10 minutes and moves within the preset radius.", 
        lblIngRadio: "Enter radius in meters* :",
        msgMovimiento: "Movement alarm enabled.",
        msgMovimientoDes: "Movement alarm disabled.",

        //Modo Horario de trabajo
        modoTrabajo: "Work at specific time",
        lblDes: "disabled",
        msgTextTrabajo: "The GPS will only turn on every certain time we program and will report the location.",
        lblTiempo: "Time* :",

        //Modo zona horaria
        modoZona: "Time zone and date setting",
        msgTextZona: "Select the time zone that applies. <br><br>" +
                     "<strong>*</strong> The states of <ins><strong>Sonora</strong></ins> and <ins><strong>Quintana Roo</strong></ins> do not participate in the daylight saving time program.",
        zonaNoroeste: "Northwest Zone",
        zonaPacifico: "Pacific Zone",
        zonaSureste: "Southeast Zone",
        zonaCentro: "Central Zone",
        lblZonaHor: "Time zone* :",
        lblZonaHoraria: "Select time zone",
        magCambioZona: "Change of time zone.",
        msgErrCambioZona: "Error sending the time zone change request.",


        //Modo sensibilidad
        modoSens: "Sensitivity setting",
        msgModalSens: "Configure the sensitivity of the shock sensor in three levels.",
        msgTextSens: "Configure the sensitivity of the shock sensor in three levels.<br><br>" + 
                     "<strong>First level:</strong> the alarm will be triggered after detecting a slight vibration once.<br><br>" + 
                     "<strong>Second level:</strong> the alarm will be triggered by detecting 8 times vibration in 2 seconds.<br><br>" +
                     "<strong>Third level:</strong> the alarm will be triggered after detecting 25 times the vibration in 5 seconds.",
        lblSens: "Sensitivity level* :",
        valPrimer: "First level: Slight vibration once",
        valSegundo: "Second level: Detect vibration 8 times in 2 seconds",
        valTercero: "Third nivel: Third level: Detect 25 times the vibration in 5 seconds.",
        msgSensibilidad: "Configuración de sensibilidad realizada con éxito.",


        //Modo Restreo Inteligente
        modoRastreoIntel: "Intelligent tracking during a time and distance interval:",
        msgModalRastreo: "Tracking over a period of time and distance",
        msgTextRastreo: "Intelligent tracking over a range of time and distance.",
        msgTextDesc: "The GPS will report a real-time location every time it travels the programmed distance.",
        lblDis: "Distance in meters*: ",
        msgRastreo: "Tracking mode activated.",
        msgConfiguracion: "Distance configuration enabled.",
        msgRastreoDistancia: "Tracking by distance and time.",


        //Modo bateria baja
        msgBateriaBaja:"Alarm indicating that the device's battery is at 20% or less. {0}",
        msgCasoTK: "In the case of TKSTAR model devices, this configuration is active by default and can't be disable.",
        msgBatBajaDes: "Low battery alarm disabled.",
        msgBatBaja: "Low battery alarm enabled.",


        //Modo Microfono
        modoRastreo: "Microphone/tracker tracking mode",
        msgHeadMicro: "Switch off: microphone mode / Switch on: tracking mode",
        msgHeadMicroTK: "Switch on: tracking mode",
        msgModalMicro: "Microphone mode and tracking mode",
        msgTextOnMicro: "<strong>Microphone on:</strong> when calling the GPS you will hear the audio from the microphone.",
        msgTextOffMicro: "<strong>Tracking mode:</strong> you will stop listening to the microphone audio, and receive the GPS location.",
        msgRastreoTK: "<strong>Tracking mode:</strong> The device will receive the GPS location.",
        msgMicrofono: "Microphone mode enabled.",

        //Modo impacto
        modoAlarma: "Impact alarm",
        msgAlarImpact: "Triggers an alert when the GPS moves, tilts, or is bumped.",
        msgAlerta: "Impact alert enabled.",
        msgAlertaDes: "Impact alarm disabled.",


        //Modo administrador
        modoConfAdmin: "Administrator Settings:",
        msgModalAdmin: "Authorization settings",
        msgTextAdmin: "Allows you to configure and authorize a cellular number as manager or remove such privileges.",
        msgAdmin: "Added manager.",
        msgEliminarAdmin: "Administrator successfully removed.",
        msgAddAdmin: "Administrator successfully added.",
        msgDelAdmin: "Administrator successfully removed.",
        msgErrSolicitud: "Error while sending the manager request.",
        msgTelValido: "Enter a valid phone number.",
        msgAddTel: "Enter a phone number",
        msgElimAdmin: "Remove manager.",
        msgErrDelAdmin: "Error sending the request to delete manager.",

        //Modo SOS
        lblSOS: "SOS configuration",
        msgConfigSOS: "Allows you to configure and authorize a cellular number as SOS.",
        msgSOS: "Allows you to configure and authorize a cellular number as SOS or to withdraw such privileges. <br><br>" +
                "There can only be one SOS number, which is the one that will receive SMS notifications of alarms.",
        msgSOSAgregado: "SOS added",
        msgSOSDel: "SOS successfully removed.",
        msgErrActualizar: "Error while updating SOS configuration",
        msgSOSAdd: "SOS successfully added.",
        msgErrSentSolicitud: "Error sending the SOS request.",
        msgDelSOS: "Delete SOS.",
        msgErrSolDelSOS: "Error while sending the SOS delete request.",

        
        //Modo estatus de dispositivo
        modoEstatus: "Device status",
        msgTextEstatus: "Allows you to check the current status of the device. Activate the switch and click on the <strong>Send</strong> "+
                        "button to send the request to the device. Wait a few seconds and you will see the status of the device in the <strong>Response</strong> field.",
        msgModalEstatus: "Allows you to check the current status of the device.",
        },
      
      //Diccionario de traducciones para la vista Dispositivos
      vDispositivos:{
        sinUsuarios: "No users",
        generarLink: "Generate link",
        copiarLink: "Copy link",
        noPermisos: "You are not allowed to view this screen",
        modelCompat:"Compatible models include:",
        y: "and",
        eliminarDispo: "Are you sure you want to remove the device?",
        msgDelDispo: "Device successfully removed.",
        msgErrDelDispo: "Device can't be deleted because it contains one or more assigned users.",
        errDelDispo: "Error while deleting device.",
        msgIngresarN: "Enter the name",
        msgPass: "Password",
        msgIngresePass: "Enter 6-digit password",
        msgFormatPass: "Correct password format.",
        msgSelecModelo: "Choose a model",
        msgFormatTel: "Correct phone format.",
        msgFormatValido: "Correct format.",
        msgGrupo: "Group",
        msgSelecGrupo: "Select a group",
        msgAsigUsers: "Assign user(s)",
        msgSaveDispo: "Save device",
        msgDato: "Data dependent on the model* :",
        msgId: "Enter 10-digit ID.",
        msgImei: "Enter 15-digit IMEI.",
        msgDispoReg: "Device registered successfully.",
        msgDispoConf: "Device configured successfully.",
        msgErroConfigDis: "Error while configuring the device.",
        msgSinConfig: "No configurations, device not configured.",
        msgImeiExiste: "Previously registered IMEI, try a different one.",
        msgSerialExiste: "Previously registered serial, try a different one.",
        msgDigitosSerial: " The serial number must have 9 digits",
        msgDigitosImei: "The IMEI must have 15 digits.",
        msgImeiDel: "IMEI registered and deleted previously, contact the administrator.",
        msgTelExiste: "Previously registered phone, try a different one.",
        msgErrorDispo: "Error while registering device.",
        msgConfigDispo: "Setting up device...",
        msgTxtDispoLink: "Generate a link to share the real-time location of {0} device.",
        msgTxtTiempoLink: "Select the time option to share the link",
        msgTxtLinkGenerado: "Here is the generated link",
        msgLinkGenerado: "Link generated successfully.",
        msgErrGenerarLink: "Error while generating link.",
        msgCadLink: "The previous access link has expired.",
        msgPorta: "The link has been copied to the clipboard.",
        msgErrPorta: "I couldn't copy the link to the clipboard.",
        msgDeviceUpdate: "Device updated successfully.",
        msgNoPosicionesLink: "There are no positions registered in the last month for the device, do you wish to continue?",
        msgNoDispositivoModelo: "The device does not have an assigned model",
        msgActualizarDispositivo: "Updating and configuring GPS device",
        agregarDispositivoGral: "Add general device",
        agregarDispositivoInst: "Add institutional device",
        dispositivoInstitucional: "Institutional device",
        dispositivoComercial: "Comercial device",
        tipoDispositivo: "Type of device",
        seleccioneDispositivo: "Select device type",
        msgErrorActualizarDispositivo: "Error updating the device."
      },

      //Diccionario de traducciones para la vista Geocercas
      vGeocercas:{
        geocerca: "Geofence",
        agregarGeocercas: "Add geofences",
        noDispo: "No devices",
        msgGeoEncontradas: "Geofences encountered.",
        msgGeoOcultas: "Geofencing was hidden.",
        dias: "Days",
        noAplica: 'Not applicable',
        erroBuscar: "Error searching for geofences.",
        eliminarGeo: "Are you sure you want to delete the geofence?",
        msgDelGeocerca: "Geofence successfully removed.",
        errDelGeocerca: "Error while deleting the geofence.",

        //Agregar Geocercas
        verForm: "View form",
        lblAsigDispo: "Assign device",
        saveGeocercas: "Save geofence",
        selectAlert: "Select an alert",
        selectMedida: "Select a length",
        metros: "Meters",
        km: "Kilometers",
        entrada: "Entry alert",
        salida: "Exit alert",
        ambos: "Both alerts",
        msgErrDibGeos: "* You can only draw one geofence.",
        msgGeoRegistrada: "Geofence registered successfully.",
        msgErrGeoReg: "The geofence was not registered.",
        msgIngreseGeo: "Enter the name of the geofence",
        msgIngreseRadio: "Enter the radius",
        msgIngreseLat: "Enter the latitude",
        msgIngreseLon: "Enter the longitude",

        //Editar Geocercas
        msgActgeo: "Geofence updated successfully.",
        msgErrGeoAct: "The geofence was not updated.",
      },

      vEstadisticas:{
        tipoBusqueda: "Search type",
        alertasDiarias: "Daily alerts",
        ultimas: "Last 24 hours",
        fechas: "By date range",
        noAlertas: "No alerts reported in the last 24 hrs.",
        noAlertasByDates: "No alerts were reported from {0} to {1}",
        msgSelectDispo: "Select a device and date(s) to start viewing its statistics.",
        tAtencion: "Attention!",
        txtAtencion: "No alerts have been recorded in the last 24 hrs. However you can perform a search from a date range.",
        msgInterceptadas: "Geofences intercepted in the last 24 hours",
        tipoGeocerca: "Types of geofences",
        numeroGeocerca: "Number of geofences",
        alertasFecha: "Alerts by date range",
        geocercaEntrada: "Entry geofence",
        geocercaSalida: "Exit geofence",
        msgNoDispositivo: "No records found for this device",
        msgNoGeocercasPorFecha: "No geofences found from {0} to {1}",
        msgErrorVerActividad: "In order to see a summary of device activity, you must have at least one device."
      },

      vHistorico:{
        presioneAgregar: "Click to add",
        seleccionado: "Selected",
        presioneEliminar: "Clic to remove",
        selecDispo: "Select a device",
        msgBusquedaFallida: "No items were found matching the search.",
        descargarExcel: "Download history in Excel",
        descargarCSV: "Download history in CSV",
        marcaInicio: "Start",
        marcaFinal: "Final",
        // irFinal: "Go to end",
        msgErrCargarPos: "Error when loading positions.",
        msgSinPos: "There are no positions within the date range.",
        msgNoPosiciones: "The device has no registered positions.",
        msgModalNoDispo: "To perform a history search you need to have at least one device.",
        msgErrorBuscarDispo: "Error while searching for devices.",
        msgErrorExportar: "Error when exporting history.",
        lblResultados: "The device has {0} positions.",
        msgPosCargadas: "Positions successfully loaded.",
        msgErrorAlertas: "Error while loading alerts.",
        msgSinAlertas: "No alerts within the date range.",
        msgErrorArchivo: "Error al exportar archivo.",

      },

      //Tablas
      dispositivos: "Devices",
      establecer: "Restore",

      //Diccionario de traducciones para la vista de usuarios
      vUsuarios:{
        agregarUsuario: "Add user",
        restablecerPass: "Reset password",
        habUser: "Are you sure you want to {0}able the user?",
        msgHabUser: "User successfully {0}abled.",
        msgContrasena: "Are you sure you want to assign a temporary password? The user must assign a new password when logging in.",
        msgAsignarContra: "Temporary password is",
        msgErrorContrasena: "Error resetting password.",
        msgVerUsuario: "Are you sure you want to see the {1} {0} workspace?",
        lblAddUser: "Enter the username",
        lblSelecRol: "Select the role",
        rol: "Role",
        lblAddPass: "Enter a password",
        msgIntroPass: "Please enter a password",
        msgErroPass:"Your password must consist of at least 3 words separated by spaces, totaling at least 12 characters",
        confirPass: "Confirm password",
        lblConfirPass: "Confirm your password",
        msgConfirPass: "Password confirmation must be exactly the same as the password",
        saveUser: "Save user",
        userReg: "User registered successfully.",
        userErr1: "Username previously registered, please try a different one.",
        msgErrRegUser:"Error registering the user.",
        msgNombreUser: "Enter the username",
        msgUserAct: "User updated successfully.",
        usuarioAdministrador: "Administrator user",
        selecUsuarioAdministrador: "Select the administrator user"
      },

      //Grupos
      vGrupos:{
        agregarGrupo: "Add group",
        guardarGrupo: "Save group",
        editarGrupo: "Edit group",
        msgHabilitar: "Are you sure you want to {frase}able the group?",
        msgHabilitarToast: "The group was successfully {frase}abled.",
        msgRegistro: "Group successfully registered.",
        msgRegistroError: "The group couldn't be registered.",
        msgActualizarError: "Error updating the group.",
        msgErrorBuscar: "Error while searching for groups.",
        msgActualizar: "Successfully updated group.",
        msgErrorActualizar: "The group couldn't be updated.",
        msgErrorHabilitar: "Error when {0}abling the group.",
        msgErrorGrupo: "Enter the group name",
        msgErrorNombreGrupo: "The name entered is already in use. Please enter a different name.",
        numeroDispositivos: "Number of devices",
        usuariosFinales: "End users",
        usuariosAdmin: "Administrator users",
      },

      vBitacora:{
        filtrado: "Select a filtering type",
        consultar: "Search",
        filtroCompleto: "Full history",
        filtroAcciones: "Actions history",
        filtroConfiguracion: "Configuration history",
        msgErrorCargar: "Error when loading logbook.",
        msgBitacoraVacia: "No logbook was found.",
        msgCargarHistorial: "History loaded successfully.",
        msgSinRegistros: "No history in selected date range.",
        presioneAgregar: "Click to add",
        seleccionado: "Selected",
        presioneEliminar: "Clic to remove",
      },

      vConfiguraciones:{
        ip: "Server IP",
        msgIp: "Enter a valid ip address.",
        numeroArduino: "Arduino phone number",
        msgNumero: "Enter 10-digit phone number.",
        msgRadio: "Radius for store static positions (meters)",
        puertoTK108: "Server port for COBAN devices",
        msgPuerto: "Enter a valid port.",
        puertoTKSTART: "Server port for TKSTAR devices",
        apn: "Telephone Company (APN)",
        ejemplo: "Example: ",
        msgErrorConfig: "Error when searching for configurations.",
        msgActualizarConfig: "Configurations successfully updated.",
        msgErrActualizar: "The configurations were not updated.",
        msgRegConfig: "Configurations registered successfully.",
        msgErrRegConfig: "The configurations were not registered.",
        intervaloAlerta: "Alerts update time interval",
        intervaloDispositivo: "Device update time interval",
        segundos: "Seconds"
      },
      
    },
  },
});